export default __webpack_public_path__ + "static/media/eCommerce.56fb7016.pdf";